import Chart from "common/components/Chart/Chart";
import { useNetworkGraphChart } from "hooks/chart/UseNetworkGraphChart";
import React, { useEffect } from "react";
import { NETWORKGRAPH } from "utils/constants";

const SocialNetworkChart = ({ data }) => {
    const {
        options: optionsNetworkGraphChartReddit,
        setOptions: setOptionsNetworkGraphChartReddit,
        showLoading,
        hideLoading,
    } = useNetworkGraphChart("", {
        enabled: true,
        useHTML: true,
        formatter: function () {
            return `
                <div style="min-width: 150px; white-space: normal;">
                    <b>Palabra</b>: ${this.point.id}
                    <br />
                    <b>Cantidad:</b> ${this.point.marker.radius}
                </div>
            `;
        },
    });

    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            showLoading(); // 🔹 Mostrar loading

            setTimeout(() => {
                setOptionsNetworkGraphChartReddit((prevOptions) => ({
                    ...prevOptions,
                    series: [
                        {
                            ...prevOptions.series[0],
                            data: data.links,
                            nodes: data.nodes.map((n) => ({
                                id: n.id,
                                marker: {
                                    radius: n.frequency,
                                },
                            })),
                        },
                    ],
                }));
                hideLoading();
            }, 100);
        } else {
            setOptionsNetworkGraphChartReddit((prevOptions) => ({
                ...prevOptions,
                series: [
                    {
                        ...prevOptions.series[0],
                        data: [],
                        nodes: [],
                    },
                ],
            }));
        }
    }, [data]);


    return (
        <Chart
            options={optionsNetworkGraphChartReddit}
            type={NETWORKGRAPH}
            onChartReady={(chart) => {
                showLoading.chartRef = chart;
            }}
        />
    );
};

export default SocialNetworkChart;
